<script setup lang="ts">
defineProps<{
  color?: any
}>()
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    :style="color"
    class="eb-icon-nosize w-10 h-10 p-1"
  >
    <circle cx="17.5" cy="17.5" r="17.5" />
    <path
      fill="#FFFFFF"
      d="M25.836,14.981c0-0.42,0.42-0.84,0.84-0.84h1.26c0.42,0,0.84-0.42,0.84-0.84V9.943
c0-0.42-0.42-0.84-0.84-0.84h-1.26c-0.84,0-3.359,1.679-3.359,8.397s2.519,8.397,3.359,8.397h1.26c0.42,0,0.84-0.42,0.84-0.84
v-3.359c0-0.42-0.42-0.84-0.84-0.84h-1.26c-0.42,0-0.84-0.42-0.84-0.84C25.836,19.347,25.836,15.653,25.836,14.981z"
    />
    <path
      fill="#FFFFFF"
      d="M9.164,20.019c0,0.42-0.42,0.84-0.84,0.84h-1.26c-0.42,0-0.84,0.42-0.84,0.84v3.359
c0,0.42,0.42,0.84,0.84,0.84h1.26c0.84,0,3.359-1.679,3.359-8.397S9.164,9.103,8.324,9.103h-1.26c-0.42,0-0.84,0.42-0.84,0.84
v3.359c0,0.42,0.42,0.84,0.84,0.84h1.26c0.42,0,0.84,0.42,0.84,0.84C9.164,15.653,9.164,19.347,9.164,20.019z"
    />
    <g>
      <path
        fill="#FFFFFF"
        d="M17.497,33.722c-0.117,0-0.227-0.023-0.332-0.07c-0.105-0.04-0.199-0.105-0.286-0.193
c-0.082-0.081-0.146-0.175-0.187-0.28c-0.047-0.105-0.07-0.222-0.07-0.333c0-0.233,0.093-0.461,0.257-0.618
c0.326-0.327,0.915-0.327,1.237,0c0.163,0.157,0.256,0.385,0.256,0.618c0,0.111-0.018,0.228-0.064,0.333
c-0.041,0.105-0.105,0.198-0.193,0.28c-0.082,0.088-0.175,0.152-0.28,0.193C17.731,33.699,17.614,33.722,17.497,33.722z"
      />
      <path
        fill="#FFFFFF"
        d="M16.622,30.287c0-0.484,0.391-0.875,0.875-0.875l0,0c0.484,0,0.875,0.391,0.875,0.875l0,0
c0,0.484-0.391,0.875-0.875,0.875l0,0C17.013,31.162,16.622,30.771,16.622,30.287z M16.622,27.732
c0-0.484,0.391-0.875,0.875-0.875l0,0c0.484,0,0.875,0.391,0.875,0.875l0,0c0,0.478-0.391,0.869-0.875,0.869l0,0
C17.013,28.601,16.622,28.21,16.622,27.732z"
      />
      <path
        fill="#FFFFFF"
        d="M16.622,25.17c0-0.484,0.391-0.875,0.875-0.875l0,0c0.484,0,0.875,0.391,0.875,0.875l0,0
c0,0.484-0.391,0.875-0.875,0.875l0,0C17.013,26.045,16.622,25.655,16.622,25.17z M16.622,22.616c0-0.484,0.391-0.875,0.875-0.875
l0,0c0.484,0,0.875,0.391,0.875,0.875l0,0c0,0.484-0.391,0.875-0.875,0.875l0,0C17.013,23.491,16.622,23.1,16.622,22.616z
 M16.622,20.055c0-0.484,0.391-0.875,0.875-0.875l0,0c0.484,0,0.875,0.391,0.875,0.875l0,0c0,0.484-0.391,0.875-0.875,0.875l0,0
C17.013,20.93,16.622,20.539,16.622,20.055z"
      />
      <path
        fill="#FFFFFF"
        d="M17.497,18.375c-0.227,0-0.449-0.093-0.618-0.257c-0.163-0.169-0.257-0.385-0.257-0.618
c0-0.059,0.006-0.117,0.018-0.169c0.011-0.059,0.029-0.111,0.052-0.163c0.023-0.052,0.047-0.105,0.081-0.152
c0.03-0.052,0.064-0.093,0.105-0.134c0.04-0.04,0.087-0.076,0.134-0.111c0.047-0.029,0.099-0.059,0.152-0.082
c0.052-0.017,0.105-0.035,0.163-0.046c0.286-0.059,0.589,0.035,0.788,0.239c0.04,0.041,0.081,0.082,0.111,0.134
c0.035,0.047,0.059,0.099,0.082,0.152c0.023,0.052,0.04,0.105,0.046,0.163c0.012,0.052,0.018,0.111,0.018,0.169
c0,0.233-0.087,0.449-0.256,0.618C17.952,18.282,17.731,18.375,17.497,18.375z"
      />
    </g>
    <g>
      <path
        fill="#FFFFFF"
        d="M20.345,18.375c-0.117,0-0.227-0.023-0.332-0.064c-0.105-0.047-0.205-0.111-0.28-0.193
c-0.088-0.081-0.152-0.175-0.193-0.286c-0.047-0.105-0.07-0.215-0.07-0.332c0-0.059,0.006-0.117,0.018-0.169
c0.011-0.059,0.029-0.111,0.052-0.163c0.023-0.052,0.047-0.105,0.082-0.152c0.029-0.052,0.069-0.093,0.111-0.134
c0.035-0.04,0.081-0.076,0.128-0.111c0.047-0.029,0.099-0.059,0.152-0.082c0.052-0.017,0.111-0.035,0.163-0.046
c0.28-0.059,0.59,0.035,0.788,0.239c0.04,0.041,0.081,0.082,0.111,0.134c0.029,0.047,0.059,0.099,0.082,0.152
c0.023,0.052,0.04,0.105,0.047,0.163c0.011,0.052,0.017,0.111,0.017,0.169c0,0.117-0.017,0.227-0.064,0.332
c-0.041,0.111-0.105,0.205-0.193,0.286c-0.082,0.082-0.175,0.146-0.28,0.193C20.578,18.352,20.461,18.375,20.345,18.375z"
      />
      <path
        fill="#FFFFFF"
        d="M14.65,18.375c-0.228,0-0.449-0.093-0.619-0.257c-0.163-0.163-0.251-0.385-0.251-0.618
c0-0.059,0.006-0.117,0.011-0.169c0.012-0.059,0.03-0.111,0.053-0.163c0.023-0.052,0.047-0.105,0.081-0.152
c0.029-0.052,0.064-0.093,0.105-0.134c0.333-0.326,0.916-0.326,1.237,0c0.041,0.041,0.082,0.082,0.111,0.134
c0.035,0.047,0.058,0.099,0.081,0.152c0.023,0.052,0.041,0.105,0.047,0.163c0.011,0.052,0.018,0.111,0.018,0.169
c0,0.233-0.088,0.449-0.257,0.618c-0.081,0.082-0.175,0.146-0.28,0.193C14.883,18.352,14.766,18.375,14.65,18.375z"
      />
    </g>
  </svg>
</template>
